import React from 'react';
import {Container, CardColumns, Card} from 'react-bootstrap';
import {VerticalTimeline, VerticalTimelineElement}  from 'react-vertical-timeline-component';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import LazyLoad from 'react-lazyload';
import 'react-vertical-timeline-component/style.min.css';
import '../styles/components/teamtimeline.css';

const endpoint = "https://files-website-fablab.s3.amazonaws.com/team/"

const team_timeline_json = [
  [ 
    { date: "2014 - 2015", title: "Fundación FabLab UTFSM, Campus San Joaquín", team:
    [
      {img:"max_rivera.jpg", name:"Max Rivera", years: "2015 - actualidad"},
      {img:"jose_dominguez.jpg", name:"José Tomás Dominguez", years: "2014 - actualidad"},
      {img:"camilo_saldias.jpg", name:"Camilo Saldías", years: "2014 - 2019"},
      {img:"jose_santibanez.jpg", name:"José Santibañez", years: "2014 - 2019"},
      {img:"leonardo_cornejo.jpg", name:"Leonardo Cornejo", years: "2014 - 2018"},
    ]},
  ],
  [ 
    { date: "2018", title:"", team: 
    [
      {img:"vicente_trincado.jpg", name:"Vicente Trincado", years: "2018"},
      {img:"diego_vera.jpg", name:"Diego Vera", years: "2018 - 2019"},
      {img:"pia_osses.jpg", name:"Pía Osses", years: "2018 - actualidad"},
      {img:"paula_castro.jpg", name:"Paula Castro", years: "2018"},
      {img:"fernanda_silva.jpg", name:"Fernanda Silva", years: "2018 - 2019"},
    ]},
  ],
  [ 
    { date: "2019", title: "", team: 
    [
      {img:"aaron_checura.jpg", name:"Aaron Checura", years: "2019"},
      {img:"alejandra_cona.jpg", name:"Alejandra Cona", years: "2019 - 2020"},
      {img:"francisco_fernandez.jpg", name:"Francisco Fernández", years: "2019"},
      {img:"pablo_albornoz.jpg", name:"Pablo Albornoz", years: "2019"},
      {img:"felipe_vergara.jpg", name:"Felipe Vergara", years: "2019 - 2020"},
      {img:"javier_delacerda.jpg", name:"Javier Delacerda", years: "2019 - actualidad"},
      {img:"vicente_lueiza.jpg", name:"Vicente Lueiza", years: "2019 - 2021"},
    ]},
  ],
  [ 
    { date: "2020", title: "", team:
    [
      {img:"fabian_rodriguez.jpg", name:"Fabián Rodriguez", years: "2020 - 2021"},
      {img:"josue_venegas.jpg", name:"Josué Venegas", years: "2020 - actualidad"},
      {img:"unknown.jpg", name:"Paloma Maldonado", years: "2020"},
      {img:"andres_ojeda.jpg", name:"Andrés Ojeda", years: "2020 - 2022"},
      {img:"diego_albornoz.jpg", name:"Diego Albornoz", years: "2020"},
      {img:"jaime_rodriguez.jpg", name:"Jaime Rodriguez", years: "2020 - 2022"},
      {img:"catalina_carreno.jpg", name:"Catalina Carreño", years: "2020"},
      {img:"ben_espinoza.jpg", name:"Ben Espinoza", years: "2020 - actualidad"},
      {img:"octavio_jacques.jpg", name:"Octavio Jacques", years: "2020 - actualidad"},
    ]},
  ],
  [ 
    { date: "2021", title: "", team:
    [
      {img:"camila_pinochet.jpg", name:"Camila Pinochet", years: "2021 - 2021"},
      {img:"tomas_nunez.jpg", name:"Tomás Nuñez", years: "2021 - actualidad"},
      {img:"nicolas_chesta.jpg", name:"Nicolás Chesta", years: "2021"},
      {img:"marcelo_ramirez.jpg", name:"Marcelo Ramírez", years: "2021"},
      {img:"fabian_riquelme.jpg", name:"Fabián Riquelme", years: "2021"},
    ]},
  ],
]

export const TeamTimeline = () =>{
  
  return (
    <Container fluid id="historico">
      <VerticalTimeline layout="1-column-left">
      {
           team_timeline_json.map((period, index) =>
           <div key={index}>
           {
              period.map(({date, title, team}, index) =>
                <VerticalTimelineElement 
                key={index}
                className="vertical-timeline-element period-team-timeline"
                position="left"
                style={{marginTop: "40px", maxWidth: '1050px'}}
                contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<FontAwesomeIcon size="lg" icon={faStar}></FontAwesomeIcon>}
                >
                  <h3 className="vertical-timeline-element-title">{date}</h3>
                  <h4 className="vertical-timeline-element-subtitle">{title}</h4>
                  <CardColumns className="card-team-timeline">
                    {
                        team.map(({img, name, years}, index) =>
                        <Card key={index} className="text-center" style={{ maxWidth: '10rem', minWidth: '10rem', marginTop: '5px', marginBottom: '5px' }}>
                          <LazyLoad height={200} offset={100}>
                            <Card.Img variant="top" src={endpoint + img}/>  
                          </LazyLoad>
                          <Card.Body>
                            <Card.Title className="text-card">{name}</Card.Title>
                            <Card.Subtitle className="subtext-card">{years}</Card.Subtitle>
                          </Card.Body>
                        </Card>
                      )
                    }
                  </CardColumns>
                </VerticalTimelineElement>
              )
            }
            </div>
           )
      }
      </VerticalTimeline>
    </Container>
  )
}